import { enableProdMode, importProvidersFrom } from '@angular/core';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserContextInterceptor } from './app/interceptors/user-context.interceptor';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { RbbTemplateModule } from '@rbb/ng-web-template-lib';
import { WebAuthModule, Organisation, WebAuthService } from '@rbb/ng-web-auth-lib';
import { WebSocketModule } from '@rbb/ng-web-socket-lib';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      WebAuthModule.forRoot({
        title: environment.title,
        authApiUrl: environment.authUrl,
        ldapInfo: true,
        userInfoUrl: undefined,
        organisations: [Organisation.RBB, Organisation.HSB, Organisation.IVZ]
      }),
      RbbTemplateModule.forRoot({
        desktopNotifications: false,
        automaticErrorMessage: false
      }),
      WebSocketModule.forRoot({
        url: environment.apiUrl.replace('http', 'ws') + '/socket',
        tokenProvider: () => WebAuthService.accessToken,
        resetToken: () => WebAuthService.reset()
      })),
    { provide: HTTP_INTERCEPTORS, useClass: UserContextInterceptor, multi: true },
    provideRouter(routes)
  ]
}).catch(err => console.error(err));
